// extracted by mini-css-extract-plugin
export default {"logo":"OrganizationAvatar_logo__vQcE4","image":"OrganizationAvatar_image__z5NAc"};